import { c as _c } from "react/compiler-runtime";
import { IcoChevronDown16 } from '@onefootprint/icons';
import type { Playbook, PlaybookVersionNoGraph } from '@onefootprint/request-types/dashboard';
import { Dropdown } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import usePlaybook from './use-playbook';
import VersionItem from './version-item';
type PlaybookVersionsDropdownProps = {
  playbook: Playbook;
  onChange?: (version: PlaybookVersionNoGraph) => void;
  defaultOpen?: boolean;
};
const PlaybookVersionsDropdown = t0 => {
  const $ = _c(35);
  const {
    playbook,
    onChange,
    defaultOpen
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "versionDropdown"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  const [open, setOpen] = useState(!!defaultOpen);
  const {
    selectedVersionNoGraph: selectedVersionWithoutGraph,
    setVersion,
    playbookVersions
  } = usePlaybook(playbook.id);
  if (!selectedVersionWithoutGraph) {
    return null;
  }
  let t2;
  if ($[1] !== onChange || $[2] !== playbookVersions || $[3] !== setVersion) {
    t2 = index => {
      setVersion(playbookVersions[index].id);
      onChange?.(playbookVersions[index]);
      setOpen(false);
    };
    $[1] = onChange;
    $[2] = playbookVersions;
    $[3] = setVersion;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleClick = t2;
  let t3;
  if ($[5] !== playbookVersions) {
    t3 = new Map(playbookVersions.map(_temp));
    $[5] = playbookVersions;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const versionNumbersById = t3;
  let t4;
  if ($[7] !== t) {
    t4 = t(_temp2);
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = !open;
  let t6;
  if ($[9] !== open || $[10] !== t5) {
    t6 = cx("flex items-center gap-2 h-7 rounded-(--button-border-radius) px-2 py-2 text-label-2 cursor-pointer transition-colors", {
      "bg-primary hover:bg-hover": t5,
      "bg-senary/70": open
    });
    $[9] = open;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== selectedVersionWithoutGraph.version || $[13] !== t) {
    t7 = t(_temp3, {
      version: selectedVersionWithoutGraph.version
    });
    $[12] = selectedVersionWithoutGraph.version;
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <IcoChevronDown16 color="tertiary" />;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t4 || $[17] !== t6 || $[18] !== t7) {
    t9 = <Dropdown.Trigger asChild={true}><button aria-label={t4} type="button" className={t6}>{t7}{t8}</button></Dropdown.Trigger>;
    $[16] = t4;
    $[17] = t6;
    $[18] = t7;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== handleClick || $[21] !== playbookVersions || $[22] !== selectedVersionWithoutGraph.id || $[23] !== versionNumbersById) {
    let t11;
    if ($[25] !== handleClick || $[26] !== selectedVersionWithoutGraph.id || $[27] !== versionNumbersById) {
      t11 = (playbookVersion, index_0) => <VersionItem createdFromVersion={playbookVersion.createdFromId ? versionNumbersById.get(playbookVersion.createdFromId) : undefined} isSelected={playbookVersion.id === selectedVersionWithoutGraph.id} key={playbookVersion.id} onClick={() => handleClick(index_0)} playbookVersion={playbookVersion} />;
      $[25] = handleClick;
      $[26] = selectedVersionWithoutGraph.id;
      $[27] = versionNumbersById;
      $[28] = t11;
    } else {
      t11 = $[28];
    }
    t10 = playbookVersions.map(t11);
    $[20] = handleClick;
    $[21] = playbookVersions;
    $[22] = selectedVersionWithoutGraph.id;
    $[23] = versionNumbersById;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[29] !== t10) {
    t11 = <Dropdown.Portal><Dropdown.Content align="start" className="min-w-[min(400px,calc(100vw-32px))] max-h-[320px] md:min-w-[400px]"><div className="flex flex-col gap-1 p-1">{t10}</div></Dropdown.Content></Dropdown.Portal>;
    $[29] = t10;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== open || $[32] !== t11 || $[33] !== t9) {
    t12 = <Dropdown.Root open={open} onOpenChange={setOpen} modal={false}>{t9}{t11}</Dropdown.Root>;
    $[31] = open;
    $[32] = t11;
    $[33] = t9;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  return t12;
};
export default PlaybookVersionsDropdown;
function _temp(t0) {
  const {
    id,
    version
  } = t0;
  return [id, version];
}
function _temp2($) {
  return $.ariaLabel;
}
function _temp3($_0) {
  return $_0.versionAbbreviation;
}